// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20wA2","question":"styles_question__3lyIr","description":"styles_description__1Y7O1"};